export default function ClearFix() {
  return <div className="clearfix"></div>;
}
